<div class="mat-dialog-wrapper depreciation-list">
  <div class="d-flex justify-space-between align-items-center mb-1">
    <h2 class="m-0" mat-dialog-title>Depreciation</h2>
    <button
      type="button"
      (click)="onCloseClick()"
      mat-button
      disableRipple
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div class="mat-table-wrapper">
      <table
        aria-describedby="Depreciation-List"
        mat-table
        [dataSource]="fixedAssetRegisterList"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="w-40">
            <mat-checkbox
              [(ngModel)]="isAllSelected"
              (change)="selectAll($event)"
              disableRipple
            ></mat-checkbox>
            Name
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex">
              <mat-checkbox [(ngModel)]="element.isSelected"> </mat-checkbox>
              {{ element.name }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef class="w-30">Amount</th>
          <td mat-cell *matCellDef="let element" class="widthemail">
            {{ element.amount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fundName">
          <th mat-header-cell *matHeaderCellDef class="w-30">Fund Name</th>
          <td mat-cell *matCellDef="let element" class="widthemail">
            <ng-select
              #fundName
              (focus)="fundName.open()"
              [(ngModel)]="
                element.fundId === commonService.defaultGuidValue
                  ? ''
                  : element.fundId
              "
              (valueChange)="fundName.close()"
              [disableOptionCentering]="true"
              panelClass="mat-select-position"
            >
              <ng-option *ngFor="let fn of fundNameList" [value]="fn.id">
                <div title="{{ fn.name }}">{{ fn.name }}</div>
              </ng-option>
            </ng-select>
          </td>
        </ng-container>

        <ng-container matColumnDef="depreciationAmount">
          <th mat-header-cell *matHeaderCellDef class="w-30">
            Depreciation Amount
          </th>
          <td mat-cell *matCellDef="let element" class="widthemail">
            <mat-form-field floatLabel="auto">
              <input
                allowDecimal
                matInput
                [(ngModel)]="element.depriciationAmount"
                autocomplete="off"
                maxlength="{{ maxLength.maxLength10 }}"
              />
            </mat-form-field>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td
            class="mat-cell"
            [ngClass]="'text-align-center'"
            [attr.colspan]="displayedColumns.length"
          >
            <span>No records found</span>
          </td>
        </tr>
      </table>
    </div>
    <app-buttons
      [getModuleId]="moduleId"
      (triggerOnSaveClick)="onSave()"
      (triggerOnCancelClick)="onCancel()"
    >
    </app-buttons>
  </mat-dialog-content>
</div>

<app-custom-notifications></app-custom-notifications>
